import React, { useEffect, useRef, useState } from "react";
import { ACTIONARROW_ICON, DELETE_ICON, EDIT_ICON, RIGHTARROW_ICON, } from "../../../utills/image-constant";
import AdminDataTable from "../../components/common/AdminDataTable";
import TableHeading from "../../components/common/TableHeading";
import SearchAndAddItem from "../../components/common/TableData";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes/url-constant";
import { CriteriactiveInactive, deleteCriteriaById, getallAdminCriteria, getAllDimensionByModelId, getAllModels, getAllSubDimensionById } from "../../../services/api-services";
import { useSelector } from "react-redux";
import moment from "moment";
import { toastEmitter } from "../../../utills/utilities";
import DropDownWithLabel from "../../components/common/DropDownWithlable";
import CriteriaBulkUpload from "./criteriaBulkUpload";
import { API_RESPONSE } from "../../../utills/app-constant";
import DeleteModal from "../../components/common/DeleteModal";

const CriteriaManagement = () => {
  const [pending, setPending] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [totalElement, settotalElement] = useState();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [sortColumn, setSortColumn] = useState("id");
  const [sortDirection, setSortDirection] = useState("desc");
  const navigate = useNavigate()
  const [modelList, setModelList] = useState([]);
  const [dimensionList, setDimensionList] = useState([]);
  const [subDimensionList, setSubDimensionList] = useState([]);
  const [modelData, setModelData] = useState("");
  const [dimensionData, setDimensionData] = useState("");
  const [subDimensionData, setSubDimensionData] = useState("");
  const { value } = useSelector((state) => state?.adminRole);
  const [permissionAccess, setPermissionAccess] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  let criteriaMenegmentModalId = localStorage.getItem("criteriaMenegmentModalId");
  let criteriaMenegmentDimesionId = localStorage.getItem("criteriaMenegmentDimesionId");
  let criteriaMenegmentSubDimesionId = localStorage.getItem("criteriaMenegmentSubDimesionId");
  const [deleteCriteriaId, setDeleteCriteriaIdId] = useState(null);
  const [deleteCriteriaName, setDeleteCriteriaName] = useState();
  const DeleteCriteriaRef = useRef()
  useEffect(() => {
    const FlashAssessmentFilterData = value?.filter(
      (v) => v.moduleName === "Campaign Management"
    );
    setPermissionAccess(FlashAssessmentFilterData?.[0]);
  }, [value]);

  const getListOfModel = async (status) => {
    try {
      const response = await getAllModels(status);
      if (response?.data?.responseCode === 404) {
        setModelList([]);
        setDimensionList([]);
        setSubDimensionList([]);
      }
      else if (response?.data?.responseCode === 200) {
        const modelOptions = response?.data?.responseBody?.map((model) => ({
          value: model.id,
          label: model.modelName,
          Status: model.status,
        }));
        setModelList(modelOptions);
      } else {
        setModelList([]);
        setDimensionList([]);
        setSubDimensionList([]);
      }
    } catch (err) {
    }
  };

  useEffect(() => {
    getListOfModel(0);
  }, []);

  const getListOfDimension = async (id) => {
    let status = modelList?.filter(v => v?.value === id)
    try {
      const response = await getAllDimensionByModelId(id, status?.[0]?.Status);
      if (response?.data?.responseCode === 404) {
        setDimensionList([]);
        setSubDimensionList([]);
      }
      else if (response?.data?.responseCode === 200) {
        const modelOptions = response?.data?.responseBody?.map((model) => ({
          value: model.id,
          label: model.dimensionName,
          Status: model.status,
        }));
        setDimensionList(modelOptions);
      } else {
        setDimensionList([]);
        setSubDimensionList([]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getListOfsubDimension = async (id) => {
    let status = dimensionList?.filter(v => v?.value === id)
    try {
      const response = await getAllSubDimensionById(id, status?.[0]?.Status);
      if (response?.data?.responseCode === 404) {
        setSubDimensionList([]);
      }
      if (response?.data?.responseCode === 200) {
        const subDimensionOptions = response?.data?.responseBody?.map((model) => ({
          value: model.id,
          label: model.subDimensionName,
          Status: model.status,
        }));
        setSubDimensionList(subDimensionOptions);
      } else {
        setSubDimensionList([]);
      }
    } catch (err) {
      console.error(err);
    }
  };


  const getListOfCriteria = async () => {
    try {
      setPending(true);
      const response = await getallAdminCriteria(page, pageSize, searchValue, sortDirection, sortColumn, criteriaMenegmentModalId ? criteriaMenegmentModalId : modelData, criteriaMenegmentDimesionId ? criteriaMenegmentDimesionId : dimensionData, criteriaMenegmentSubDimesionId ? criteriaMenegmentSubDimesionId : subDimensionData);
      if (response?.data?.responseCode === 200) {
        setRowData(response?.data?.responseBody?.criteriaResponsePayloadList);
        settotalElement(response?.data?.responseBody?.totalElement);
        setPending(false);
      } else {
        setRowData([]);
        setPending(false);
      }

    } catch (err) {
      setPending(false);
    }
  };

  useEffect(() => {
    getListOfCriteria();
  }, [page, pageSize, totalElement, searchValue, sortColumn, sortDirection, modelData, dimensionData, subDimensionData, criteriaMenegmentSubDimesionId, criteriaMenegmentDimesionId, criteriaMenegmentModalId]);

  useEffect(() => {
    if (criteriaMenegmentModalId && modelList && modelList.length > 0) {
      getListOfDimension(criteriaMenegmentModalId);
    }
  }, [criteriaMenegmentModalId, modelList]);

  useEffect(() => {
    if (criteriaMenegmentDimesionId && dimensionList && dimensionList.length > 0) {
      getListOfsubDimension(criteriaMenegmentDimesionId);
    }
  }, [criteriaMenegmentDimesionId, dimensionList]);

  const tableCustomStyles = {
    headRow: {
      style: {
        color: "#1B2128",
        fontSize: "12px",
      },
    },
    rows: {
      style: {
        color: "#1B2128",
        fontSize: "14px",
      },
    },
  };


  const handleStatusChange = async (row) => {
    const newStatus = row?.status === 1 ? 0 : 1; // Toggle the status

    // Optimistically update the status in the local rowData
    const updatedRowData = rowData.map((item) =>
      item.id === row.id ? { ...item, status: newStatus } : item
    );
    setRowData(updatedRowData); // Update local state with the new status

    try {
      let response = await CriteriactiveInactive(row.id, newStatus);

      if (response?.data?.responseCode === 200) {
        toastEmitter("success", response?.data?.message);
      } else {
        // If the API fails, revert the status in local state
        const revertRowData = rowData.map((item) =>
          item.id === row.id ? { ...item, status: row?.status } : item
        );
        setRowData(revertRowData);
        console.error("Failed to update model status");
      }
    } catch (error) {
      // If there's an error, revert the status in local state
      const revertRowData = rowData.map((item) =>
        item.id === row.id ? { ...item, status: row?.status } : item
      );
      setRowData(revertRowData);
      console.error("Error during status change:", error);
    }
  };

  const deleteButtonClick = (id, name) => {
    setDeleteCriteriaIdId(id)
    setDeleteCriteriaName(name)
    DeleteCriteriaRef.current.click();
  }

  const handleCriteriaDelete = async () => {
    try {
      const response = await deleteCriteriaById(deleteCriteriaId);
      if (response?.data?.responseCode === 200) {
        toastEmitter('success', response.data.message)
        getListOfCriteria();
      } else {
        toastEmitter('error', response.data.message || API_RESPONSE?.MESSAGE_500)
      }
    } catch (err) {
      // toastEmitter('error', response.data.message || API_RESPONSE?.MESSAGE_500)
    }
  }

  const tblColumns = [
    ...(permissionAccess?.updateAction === 1
      ? [
        {
          code: "Action",
          name: "Action",
          width: "130px",
          sortable: false,
          cell: (row) => (
            <div>
              <button
                className="border-0 bg-white"
                onClick={() =>
                  navigate(ROUTES?.ADDCRITERIA, {
                    state: { pageType: "Edit", Data: row },
                  })
                }
              >
                <img src={EDIT_ICON} alt="Edit" className="editicon" />
              </button>
              <span>
                <button className="border-0 bg-white" onClick={() => navigate(ROUTES.ADDCRITERIA, { state: { pageType: "view", Data: row } })}>
                  <img src={ACTIONARROW_ICON} alt="View" className="editicon ms-2" />
                </button>
              </span>
              <span>
                <button
                  className="border-0 bg-white"
                  onClick={() => deleteButtonClick(row?.id, row?.criteriaShortLabel)}
                >  <img src={DELETE_ICON} alt="View" className="editicon ms-2" />
                </button>
              </span>
            </div>
          ),
        },
      ]
      : []),
    {
      code: "criteriaId",
      name: "Criteria Id",
      width: "110px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.criteriaId}</div>
      ),
    },
    {
      code: "criteriaShortLabel",
      name: "Short Name",
      width: "200px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.criteriaShortLabel}</div>
      ),
    },
    {
      code: "criteriaDescription",
      name: "Description",
      width: "350px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.criteriaDescription}</div>
      ),
    },
    {
      code: "modelName",
      name: "Model Name",
      width: "180px",
      sortable: true,
      selector: (row) => (<div className="table-cell-content">{row?.modelResponse?.modelName}</div>),
    },
    {
      code: "dimensionName",
      name: "Dimension Name",
      width: "160px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.dimensionResponse?.dimensionName}</div>
      ),
    },
    {
      code: "subDimensionName",
      name: "Sub-Dimension",
      width: "200px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.subDimensionResponse?.subDimensionName}</div>
      ),
    },
    {
      code: "status",
      name: "Status",
      width: "140px",
      omit: false,
      sortable: true,
      cell: (row) => (
        <div className="form-switch-btn">
          <label className="switch">
            <input
              disabled={permissionAccess?.moduleAction === 0}
              type="checkbox"
              id="togBtn"
              checked={row?.status === 1}
              onChange={() => handleStatusChange(row)}
            />
            <div className="slider round">
              {row?.status === 1 ? (
                <span className="on">Active</span>
              ) : (
                <span className="off">Inactive</span>
              )}
            </div>
          </label>
        </div>
      ),
    },
    {
      code: "createdDate",
      name: "Last Update",
      sortable: true,
      width: "140px",
      selector: (row) => moment(row?.createdDate).format("MM/DD/YYYY"), // Adjust format as needed
    },

  ];


  const onSearchChange = (e) => {
    setSearchValue(e.target.value);
    // Filter rowData based on the search te
  };


  const handleSelectValue = (event) => {
    const { name, value } = event.target;
    if (value == "") {
      localStorage.removeItem("criteriaMenegmentModalId");
      localStorage.removeItem("criteriaMenegmentDimesionId");
      localStorage.removeItem("criteriaMenegmentSubDimesionId");
      setModelData("");
      setSubDimensionData("")
      setDimensionData("")
      setSubDimensionList([])
      setDimensionList([])
    } else {
      if (name === "modelList") {
        localStorage.setItem("criteriaMenegmentModalId", value);
        setModelData(value);
        setSubDimensionData("")
        setDimensionData("")
        getListOfDimension(value);
      } else if (name === "dimensionList") {
        getListOfsubDimension(value)
        setDimensionData(value)
        localStorage.setItem("criteriaMenegmentDimesionId", value);
      } else if (name === "subDimensionList") {
        localStorage.setItem("criteriaMenegmentSubDimesionId", value);
        setSubDimensionData(value)
      }
    }

  };
  const addButtonClick = () => {
    navigate(ROUTES.ADDCRITERIA);
  }

  useEffect(() => {
    if (dimensionData == "") {
      setSubDimensionData("")
    }
  }, [dimensionData])

  const handleClearAll = () => {
    localStorage.removeItem("criteriaMenegmentModalId");
    localStorage.removeItem("criteriaMenegmentDimesionId");
    localStorage.removeItem("criteriaMenegmentSubDimesionId");
    setModelData("");
    setSubDimensionData("");
    setDimensionData("");
    getListOfDimension("");
    getListOfsubDimension("");
    setSubDimensionList([]);
    setDimensionList([]);
  }

  return (
    <>
      <div className="criteria_datatable">
        <div>
        </div>
        <TableHeading firstData="Assessment Modeling" icon={RIGHTARROW_ICON} secondData="Criteria Management" />
        <div className="container-fluid ">
          <div className="caspera_admin_datatable mb-3">
            <SearchAndAddItem searchValue={searchValue} addButtonClick={addButtonClick} showuploadbtn={true} onSearchChange={onSearchChange} permissionAccessbtn={permissionAccess?.addAction} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} data='Criteria' />
            <div className="row mb-4">
              <div className="col-12 col-lg-3">
                <DropDownWithLabel
                  name="modelList"
                  labelName="Select Maturity Model"
                  className="addInputText-lable"
                  lableclassName="addInput-label"
                  options={modelList}
                  value={criteriaMenegmentModalId ? criteriaMenegmentModalId : modelData}
                  handleSelect={handleSelectValue}

                />
              </div>
              <div className="col-12 col-lg-3">
                <DropDownWithLabel
                  labelName="Select Dimension"
                  name="dimensionList"
                  options={dimensionList}
                  lableclassName="addInput-label"
                  value={criteriaMenegmentDimesionId ? criteriaMenegmentDimesionId : dimensionData}
                  handleSelect={handleSelectValue}
                  className="addInputText-lable"
                />
              </div>
              <div className="col-12 col-lg-3">
                <DropDownWithLabel
                  labelName="Select Sub-Dimension"
                  name="subDimensionList"
                  options={subDimensionList}
                  lableclassName="addInput-label"
                  value={criteriaMenegmentSubDimesionId ? criteriaMenegmentSubDimesionId : subDimensionData}
                  handleSelect={handleSelectValue}
                  className="addInputText-lable"
                />
              </div>
              <div className="col-12 col-lg-3">
                <button className="border-0 bg-primary text-white rounded-2 p-1 clearall-btn w-100 mt-3 textfont12" onClick={handleClearAll}>Clear All</button>
              </div>
            </div>
            <AdminDataTable
              _tblColumns={tblColumns}
              _rowData={rowData}
              tableCustomStyles={tableCustomStyles}
              _totalRows={totalElement}
              pending={pending}
              setPending={setPending}
              pageSize={pageSize}
              setPageSize={setPageSize}
              setPage={setPage}
              setSortDirection={setSortDirection}
              setSortColumn={setSortColumn}
            />
          </div>
        </div>
      </div>

      <CriteriaBulkUpload isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} getListOfCriteria={getListOfCriteria} />
      <DeleteModal
        DeleteModalRef={DeleteCriteriaRef}
        title="Criteria"
        name={deleteCriteriaName}
        handleDelete={handleCriteriaDelete}
      />
    </>
  );
};

export default CriteriaManagement;
